export default function() {

    this.debug=function(){

    };//console.log;
    this.error=console.error;
    this.warn=console.warn;
    this.info=console.info;

/*
    this.debug = function(content){
      console.log(content);
    };
    this.error = function(content){
      console.error(content);
    };
    this.warn = function(content){
      console.warn(content);
    };
    this.info = function(content){
      console.info(content);
    };
*/
}



// WEBPACK FOOTER //
// ./src/Tools/logger.js